<div class="close-page" (click)="close()">
    <img src="./assets/img/close.png" alt="Zamknij">
</div>